export enum ProductTypeEnum {
  Ticket = 1,
  DeliveryMethod = 2,
  PaymentMethod = 3,
  Membership = 4,
  Discount = 5,
  CrossSellProduct = 6,
  MatchDayPass = 7
}
